import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import Raven from 'raven-js';
// copied from file of the same name in inbox-message-history
export const copyToClipboard = text => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).catch(error => {
      Raven.captureException(error);
    });
  } else {
    // TODO remove this work around when navigator.clipboard.writeText is fully supported by all browsers
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.focus();
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
  }
};
export const copyWithFloatingMessage = (text, floatingMessage) => {
  copyToClipboard(text);
  FloatingAlertStore.addAlert({
    message: floatingMessage
  });
};